import React from 'react';
import styles from './App.module.scss';

interface Props {
    head: string,
    subHead: string
}

const Heading: React.FC<Props> = ({ head, subHead }) => {
    return (
        <div className={styles.heading}>
            <h2>{head}</h2>
            <h6>{subHead}</h6>
        </div>
    );
}

export default Heading;